import React, { createContext, useContext, useState, useEffect } from 'react';

const API_BASE = '/api';  // Adjust if your API is in a subdirectory

const AuthContext = createContext(null);

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [access, setAccess] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    checkSession();
  }, []);

  const checkSession = async () => {
    try {
      const response = await fetch(`${API_BASE}/session.php`, {
        credentials: 'include'  // Important for cookies
      });
      const data = await response.json();

      if (data.authenticated) {
        setUser({
          email: data.user.email,
          displayName: data.user.name,
          photoURL: data.user.picture
        });
        setAccess({
          sections: data.user.sections,
          role: data.user.role
        });
      } else {
        setUser(null);
        setAccess(null);
      }
    } catch (err) {
      console.error('Session check error:', err);
      setError('Failed to check session');
    } finally {
      setLoading(false);
    }
  };

  const login = async () => {
    try {
      setError(null);
      // Redirect to PHP login endpoint
      window.location.href = `${API_BASE}/login.php`;
    } catch (err) {
      console.error('Login error:', err);
      setError('Failed to initiate login');
      throw err;
    }
  };

  const logout = async () => {
    try {
      await fetch(`${API_BASE}/logout.php`, {
        credentials: 'include',
        method: 'POST'
      });
      setUser(null);
      setAccess(null);
      window.location.href = '/';
    } catch (err) {
      console.error('Logout error:', err);
    }
  };

  const value = {
    user,
    access,
    loading,
    error,
    login,
    logout,
    isAuthenticated: !!user && !!access && access.sections?.length > 0
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}